import axios from "axios";
import {server} from "@/variables";

export function getStat(obj) {
    let {dateFromNotifications, dateTillNotifications} = obj;
    let {dateTillOrders, dateFromOrders} = obj;
    let {dateFromPriceRequests, dateTillPriceRequests} = obj;
    let params = '';
    let added = false;
    if (dateFromNotifications) {
        params += `${added ? '&' : ''}dateFromNotifications=${dateFromNotifications}`;
        added = true;
    }
    if (dateTillNotifications) {
        params += `${added ? '&' : ''}dateTillNotifications=${dateTillNotifications}`;
        added = true;
    }
    if (dateTillOrders) {
        params += `${added ? '&' : ''}dateTillOrders=${dateTillOrders}`;
        added = true;
    }
    if (dateFromOrders) {
        params += `${added ? '&' : ''}dateFromOrders=${dateFromOrders}`;
        added = true;
    }
    if (dateFromPriceRequests) {
        params += `${added ? '&' : ''}dateFromPriceRequests=${dateFromPriceRequests}`;
        added = true;
    }
    if (dateTillPriceRequests) {
        params += `${added ? '&' : ''}dateTillPriceRequests=${dateTillPriceRequests}`;
        added = true;
    }
    if (added) {
        params = '?' + params;
    }
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/stat${params}`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}


export function getK() {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/k`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data.k)
            })
            .catch(err => {
                reject(err);
            });
    })
}

export function setK(k) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.post(`${server}/k`, {k}, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}